import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Producto, CreateProductoDto, UpdateProductoDto } from '../producto.model';

/**
 * Servicio para gestionar operaciones CRUD de productos
 * Los errores HTTP son manejados automáticamente por el errorInterceptor
 */
@Injectable({
  providedIn: 'root'
})
export class ProductosService {

  private readonly URL = environment.URL;

  constructor(private readonly http: HttpClient) { }

  /**
   * Agrega un nuevo producto
   * @param producto - Datos del producto a crear (puede ser FormData si incluye imagen)
   * @returns Observable con la respuesta del servidor
   */
  addProducto(producto: CreateProductoDto | FormData): Observable<any> {
    return this.http.post<any>(this.URL + 'addProducto', producto);
  }

  /**
   * Actualiza los datos de un producto
   * @param data - Nuevos datos del producto (puede ser FormData si incluye imagen)
   * @param idProducto - ID del producto a actualizar
   * @returns Observable con la respuesta del servidor
   */
  editProducto(data: UpdateProductoDto | FormData, idProducto: string): Observable<any> {
    return this.http.put<any>(this.URL + `editProducto/${idProducto}`, data);
  }

  /**
   * Obtiene la lista completa de productos
   * @returns Observable con el array de productos
   */
  getProductos(): Observable<Producto[]> {
    return this.http.get<Producto[]>(this.URL + 'getProductos');
  }

  /**
   * Busca un producto por su ID
   * @param idProducto - ID del producto a buscar
   * @returns Observable con los datos del producto
   */
  listProductoId(idProducto: string): Observable<Producto> {
    return this.http.get<Producto>(this.URL + `/searchProductoId/${idProducto}`);
  }

  /**
   * Elimina un producto por su ID
   * @param idProducto - ID del producto a eliminar
   * @returns Observable con la respuesta del servidor
   */
  deleteProducto(idProducto: string): Observable<any> {
    return this.http.delete<any>(this.URL + `deleteProducto/${idProducto}`);
  }
}